var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","to":"/cart"}},[_c('v-icon',[_vm._v("mdi-cart-variant")]),_vm._v(" ("+_vm._s(_vm.numberOfProducts())+") ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }